// import { Bounce, ToastContainer, ToastContainerProps } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// /**
//  * Monta um ToastContainer local da página.
//  * Use um containerId ÚNICO por página/rota.
//  */
// export default function PageToaster({
//   containerId,
//   ...props
// }: { containerId: string } & Partial<ToastContainerProps>) {
//   return (
//     <ToastContainer
//       // ❌ enableMultiContainer -> REMOVIDO na v9
//       containerId={containerId}
//       position="top-right"
//       autoClose={5000}
//       closeOnClick
//       pauseOnHover={false}
//       pauseOnFocusLoss={false}
//       draggable
//       newestOnTop
//       limit={3}
//       theme="light"
//       transition={Bounce}
//       style={{ zIndex: 99999 }}
//       {...props}
//     />
//   );
// }

import { Bounce, ToastContainer, ToastContainerProps } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * Monta um ToastContainer local da página.
 * Use um containerId ÚNICO por página/rota.
 */
export default function PageToaster({
  containerId,
  ...props
}: { containerId: string } & Partial<ToastContainerProps>) {
  return (
    <ToastContainer
      containerId={containerId}
      position="top-right"
      autoClose={5000}
      closeOnClick
      pauseOnHover={false}
      pauseOnFocusLoss={false}
      draggable
      newestOnTop
      limit={5}
      theme="light"
      transition={Bounce}
      style={{ zIndex: 99999 }}
      {...props}
    />
  );
}
